import { render, staticRenderFns } from "./InstructionText.vue?vue&type=template&id=c912bcd8&scoped=true&"
import script from "./InstructionText.vue?vue&type=script&lang=js&"
export * from "./InstructionText.vue?vue&type=script&lang=js&"
import style0 from "./InstructionText.vue?vue&type=style&index=0&id=c912bcd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c912bcd8",
  null
  
)

export default component.exports